


































import { Component, Prop, Vue } from 'vue-property-decorator'
import ICurrency from '@/models/ICurrency'
import IStat from '@/models/IStat'
import IAccount from '../models/IAccount'
import { findContrastColor } from '@/utils'

@Component({
  components: {
    'axis-label': () => import('@/components/AxisLabel.vue')
  }
})
export default class ChartBalance extends Vue {
  @Prop({ type: Object, required: true })
  public account!: IAccount
  @Prop({ type: Array, default: () => [] })
  public stats!: IStat[]
  @Prop({ type: Object, required: true })
  public currency!: ICurrency

  public getColor(amount: number): string {
    return amount === 0 ? 'zero' : amount > 0 ? 'positive' : 'negative'
  }

  public get colorStyle() {
    if (!this.account) {
      return {}
    }
    return {
      backgroundColor: this.account.color,
      color: findContrastColor(this.account.color)
    }
  }

  public get statOrdered(): IStat[] {
    return [...this.stats].sort((a: IStat, b: IStat) =>
      a.balance.amount < b.balance.amount ? 1 : -1
    )
  }

  public get totalCost(): number {
    return this.stats.reduce((a: number, b: IStat) => a + b.value, 0)
  }
}
